module.exports = __webpack_public_path__ + "static/media/blue_bike.a7a12bff.png";